import React from 'react';
import Header from '../../organisms/Header/Header';
import rabbitXHeroBackground from '../../../assets/images/rabbitX/hero_bg.webp';
import rabbitXRings from '../../../assets/images/rabbitX/rabbitXbg.webp';
import Constants from '../../../app/utils/constants';
import colors from '../../theme/color';
import { motion } from 'framer-motion'

const HeroSection = () => {
  const highlightCards = Constants.rabbitxHeroHighlights;

  return (
    <section className="relative isolate w-full overflow-hidden pb-24 md:pb-32 lg:pb-40 2xl:pb-48 min-[2560px]:pb-56">
      <div className="pointer-events-none absolute inset-0 z-10">
        <div className="absolute inset-0" style={{ backgroundColor: colors.rabbitXPageBg }} />
        <img
          src={rabbitXHeroBackground}
          alt=""
          className="absolute inset-0 h-full w-full scale-[1] object-cover object-[66%_0%] opacity-[0.46] blur-[2.5px] [-webkit-mask-image:linear-gradient(180deg,rgba(0,0,0,1)_0%,rgba(0,0,0,0.95)_28%,rgba(0,0,0,0.76)_46%,rgba(0,0,0,0.42)_60%,rgba(0,0,0,0.16)_74%,rgba(0,0,0,0.04)_86%,rgba(0,0,0,0)_100%)] [mask-image:linear-gradient(180deg,rgba(0,0,0,1)_0%,rgba(0,0,0,0.95)_28%,rgba(0,0,0,0.76)_46%,rgba(0,0,0,0.42)_60%,rgba(0,0,0,0.16)_74%,rgba(0,0,0,0.04)_86%,rgba(0,0,0,0)_100%)]"
        />
        <div className="absolute inset-0" style={{ backgroundColor: `${colors.rabbitXAccent}0D` }} />
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 15% 10%, ${colors.rabbitXAccent}24 0%, ${colors.rabbitXGlowPurple}1A 42%, rgba(13,8,33,0.2) 72%, rgba(7,4,20,0.34) 100%)`,
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(7,3,18,0.02) 0%, rgba(7,3,18,0.12) 60%, rgba(7,3,18,0.42) 100%)`,
          }}
        />
      </div>

      <div className="relative w-full">
        <Header />
      </div>

      <div className="relative z-20 mx-auto mt-24 w-full max-w-[1380px] px-5 md:mt-34 md:px-8 lg:mt-40 lg:px-12 2xl:max-w-[1800px] 2xl:px-16 min-[2560px]:max-w-[2400px] min-[2560px]:px-24">
        <div className="relative mx-auto flex max-w-[860px] flex-col items-center pt-30 text-center md:pt-8 lg:pt-10 2xl:max-w-[1100px] min-[2560px]:max-w-[1500px]">
          <div className="pointer-events-none absolute left-1/2 top-[-40px] -z-50 aspect-square w-[400px] -translate-x-1/2 overflow-hidden rounded-full sm:top-[-42px] sm:w-[540px] md:top-[-58px] md:w-[720px] lg:top-[-82px] lg:w-[820px] 2xl:top-[-88px] 2xl:w-[960px] min-[2560px]:top-[-104px] min-[2560px]:w-[1140px]">
            <motion.img
  src={rabbitXRings}
  alt=""
  animate={{ rotate: 360 }}
  transition={{
    repeat: Infinity,
    duration: 25, // slower = more premium
    ease: "linear",
  }}
  className="h-auto w-full scale-[1.12] object-contain opacity-[0.4] mix-blend-screen blur-[0.9px] [filter:saturate(112%)_brightness(0.98)] [-webkit-mask-image:radial-gradient(ellipse_at_50%_60%,rgba(0,0,0,0.98)_22%,rgba(0,0,0,0.9)_42%,rgba(0,0,0,0.46)_58%,rgba(0,0,0,0.14)_72%,rgba(0,0,0,0)_86%)] [mask-image:radial-gradient(ellipse_at_50%_60%,rgba(0,0,0,0.98)_22%,rgba(0,0,0,0.9)_42%,rgba(0,0,0,0.46)_58%,rgba(0,0,0,0.14)_72%,rgba(0,0,0,0)_86%)]"
/>
          </div>

          <h1 className="font-gilroy-bold text-[3.2rem] leading-[0.9] tracking-[0.02em] text-white drop-shadow-[0_6px_25px_rgba(0,0,0,0.4)] sm:text-[4rem] md:text-[5rem] lg:text-[5.6rem] 2xl:text-[7rem] min-[2560px]:text-[9.5rem]">
            RABBITX
          </h1>
          <p className="mt-3 max-w-[960px] font-gilroy-medium text-[1.3rem] leading-[1.18] text-white sm:text-[2rem] md:text-[2.2rem] lg:text-[2.95rem] 2xl:text-[3.4rem] 2xl:max-w-[1200px] min-[2560px]:max-w-[1600px] min-[2560px]:text-[4.5rem]">
            A Modern Approach to Crypto Derivatives Trading
          </p>
        </div>

        <div className="mx-autoh-auto mt-35 grid max-w-[1120px] grid-cols-1 gap-5 md:mt-26 md:grid-cols-3 lg:mt-32 lg:grid-cols-3 2xl:mt-36 2xl:max-w-[1600px] 2xl:gap-8 min-[2560px]:mt-44 min-[2560px]:max-w-[2200px] min-[2560px]:gap-12">
          {highlightCards.map((card, index) => (
            <motion.article
              key={card.title}
              initial={{ opacity: 0, y: 100, rotate: 12 }}
              animate={{ opacity: 1, y: 0, rotate: 0 }}
              transition={{
                duration: 1.4,
                delay: index * 0.35,
                type: 'spring',
                bounce: 0.25,
              }}
              className="min-h-[40px] rounded-[22px] p-[1px] shadow-[0_22px_50px_rgba(4,2,12,0.45)] md:min-h-[150px] 2xl:min-h-[280px] 2xl:rounded-[28px] min-[2560px]:min-h-[360px] min-[2560px]:rounded-[36px]"
              style={{
                backgroundImage: `linear-gradient(138.94deg, ${colors.rabbitXAccent} 0%, ${colors.rabbitXAccent}1A 50%, ${colors.rabbitXAccent} 100%)`,
              }}
            >
              <div
                className="relative h-auto lg:h-full overflow-hidden rounded-[22px] px-6 py-4 backdrop-blur-[8px] md:px-7 md:py-5 2xl:rounded-[28px] 2xl:px-10 2xl:py-8 min-[2560px]:rounded-[36px] min-[2560px]:px-14 min-[2560px]:py-12"
                style={{
                  backgroundImage: `linear-gradient(135deg, ${colors.rabbitXAccent}3D 0%, ${colors.rabbitXGlowPurple}33 32%, rgba(17,10,30,0.92) 68%, ${colors.rabbitXCardDark} 100%)`,
                  backgroundColor: `${colors.rabbitXCardDark}F2`,
                }}
              >
                <div
                  aria-hidden
                  className="pointer-events-none absolute inset-0 z-0"
                  style={{ backgroundImage: `linear-gradient(130.84deg, ${colors.rabbitXHighlightCardGlowStart} 0%, rgba(34, 9, 36, 0) 20.19%)` }}
                />
                <div className="relative z-10">
                  <h2 className="font-rajdhani text-[1.5rem] md:text-[2rem] font-semibold leading-none text-white 2xl:text-[2.75rem] min-[2560px]:text-[3.75rem]">{card.title}</h2>
                  <ul className="mt-4 space-y-2.5 2xl:mt-6 2xl:space-y-4 min-[2560px]:mt-8 min-[2560px]:space-y-5">
                    {card.items.map((item) => (
                      <li
                        key={item}
                        className="flex items-start gap-2.5 font-gilroy-medium text-[1rem] leading-[1.28] lg:text-[1.25rem] 2xl:text-[1.5rem] 2xl:gap-4 min-[2560px]:text-[2.1rem] min-[2560px]:gap-5"
                        style={{ color: `${colors.rabbitXTextLight}D9` }}
                      >
                        <span
                          className="mt-[0.55rem] h-1.5 w-1.5 shrink-0 rounded-full 2xl:mt-[0.65rem] 2xl:h-2 2xl:w-2 min-[2560px]:mt-3 min-[2560px]:h-3 min-[2560px]:w-3"
                          style={{ backgroundColor: `${colors.rabbitXTextLight}CC` }}
                        />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default HeroSection;
